<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('my_requests')" :isFilter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('my_requests')" :isFilter="false" />
            </template>

            <b-tabs content-class="py-5 position-relative" v-model="tabIndex">
                <div class="tabs-bottom-line"></div>

                <!-- İzin Talebi (Kayıt Dondurma) -->
                <b-tab :disabled="!checkPermission('leaveofabsence_student')">
                    <template #title>
                        <span v-if="checkPermission('leaveofabsence_student')" class="d-flex align-items-center">
                            {{ $t('leave_of_absence') }}
                        </span>
                    </template>
                    <leave-of-absence-tab v-if="tabIndex === 0" />
                </b-tab>

                <!-- İzinli Ayrılma Talebi -->
                <b-tab :disabled="!checkPermission('leavewithconsent_student')">
                    <template #title>
                        <span v-if="checkPermission('leavewithconsent_student')" class="d-flex align-items-center">
                            {{ $t('leave_with_consent') }}
                        </span>
                    </template>
                    <leave-with-consent-tab v-if="tabIndex === 1" />
                </b-tab>

                <!-- İade Talebi -->
                <b-tab :disabled="!checkPermission('refundrequest_student')">
                    <template #title>
                        <span v-if="checkPermission('refundrequest_student')" class="d-flex align-items-center">
                            {{ $t('refund') }}
                        </span>
                    </template>
                    <refund-tab v-if="tabIndex === 2" />
                </b-tab>

                <!-- Ders Transferi (İntibak) -->
                <b-tab :disabled="!checkPermission('coursetransfer_student')">
                    <template #title>
                        <span v-if="checkPermission('coursetransfer_student')" class="d-flex align-items-center">
                            {{ $t('course_transfer') }}
                        </span>
                    </template>
                    <course-transfer-tab v-if="tabIndex === 3" />
                </b-tab>

                <!-- Belge Talebi -->
                <b-tab :disabled="!checkPermission('documentrequest_student')" 
                       :title-item-class="{'minus-150': stateData.active_role?.name === 'ALUMNI'}">
                    <template #title>
                        <span v-if="checkPermission('documentrequest_student')" class="d-flex align-items-center">
                            {{ $t('document_request') }}
                        </span>
                    </template>
                    <document-request-tab v-if="tabIndex === 4" :state-data="stateData" />
                </b-tab>

                <!-- Ders Mutabakatı -->
                <b-tab :disabled="!checkPermission('courseagreement_student')">
                    <template #title>
                        <span v-if="checkPermission('courseagreement_student')" class="d-flex align-items-center">
                            {{ $t('course_agreement') }}
                        </span>
                    </template>
                    <course-agreement-tab v-if="tabIndex === 5" />
                </b-tab>

                <!-- Staj Başvurusu -->
                <b-tab :disabled="!checkPermission('internshipapplication_me')">
                    <template #title v-if="checkPermission('internshipapplication_me')">
                        <span>{{ $t('internship_application') }}</span>
                    </template>
                    <internship-application-tab v-if="tabIndex === 6" />
                </b-tab>
            </b-tabs>
        </app-layout>
    </div>
</template>

<script>
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

// Tab Components
import LeaveOfAbsenceTab from "../components/Requests/LeaveOfAbsenceTab.vue";
import LeaveWithConsentTab from "../components/Requests/LeaveWithConsentTab.vue";
import RefundTab from "../components/Requests/RefundTab.vue";
import CourseTransferTab from "../components/Requests/CourseTransferTab.vue";
import DocumentRequestTab from "../components/Requests/DocumentRequestTab.vue";
import CourseAgreementTab from "../components/Requests/CourseAgreementTab.vue";
import InternshipApplicationTab from "../components/Requests/InternshipApplicationTab.vue";

/**
 * Requests Page
 * Main container for various student requests.
 */
export default {
    name: 'Requests',
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        LeaveOfAbsenceTab,
        LeaveWithConsentTab,
        RefundTab,
        CourseTransferTab,
        DocumentRequestTab,
        CourseAgreementTab,
        InternshipApplicationTab
    },
    data() {
        return {
            tabIndex: 4, // Default to Document Request tab
            stateData: {},
        };
    },
    metaInfo() {
        return {
            title: this.$t("my_requests")
        }
    },
    created() {
        this.$store.dispatch("auth/initUser");
        this.stateData = {
            ...this.$store.getters['auth/getUser']
        };

        if (this.$route.params.tab !== undefined) {
            this.tabIndex = parseInt(this.$route.params.tab);
        }
    }
};
</script>

<style lang="scss">
.document_request_dropdown {
    tr {
        td:first-child {
            padding-right: 0px !important;
        }
    }
}

.minus-150 {
    margin-left: -150px;
}
</style>
